module.exports = __webpack_public_path__ + "static/media/message-question.b7d4ec4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/message-question.svg
// module id = 322
// module chunks = 1